import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Table } from "antd";
import DatePicker from "react-datepicker";
import CreatableSelect from "react-select/creatable";
import formatError from "../../services/FormatError";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { loginConfirmedAction } from "../../store/actions/AuthActions";
import { sortList } from "./Users";
import { modifyDate } from "./Business";
import { fetchActiveCurrencies } from "../../services/Currencies";
import config from "../../config";
import {
  addBuyerProfile,
  deleteBuyerProfile,
  fetchAllBuyers,
  fetchBuyerDetails,
} from "../../services/BuyerService";
import { useTranslation } from "react-i18next";
import { getBase64 } from "./Registration";
import swal from "sweetalert";
import { set } from "date-fns";
import { countryOptions } from "../../utils/countryOptions";
import { municipaliteis } from "../../utils/municipalities";
import { provinces, regionsData } from "../../utils/regionsData";
import { MultiSelect } from "react-multi-select-component";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

export const dateFormatter = (date) => {
  const dateObject = new Date(date);

  const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObject.getDate().toString().padStart(2, "0");
  const year = dateObject.getFullYear();

  return `${month}/${day}/${year}`;
};

const validateBuyer = (data) => {
  if (
    data?.name !== "" &&
    data?.email !== "" &&
    data?.contactName !== "" &&
    data?.contactEmail !== "" &&
    data?.phone !== "" &&
    data?.industriesOpt?.length !== 0 &&
    data?.interestedLocationsOpt?.length !== 0 &&
    data?.investmentrange !== "" &&
    data?.country !== "" &&
    data?.region !== "" &&
    data?.currency !== "" &&
    data?.domain !== "" &&
    data?.occupation !== "" &&
    data?.startservice !== ""
  ) {
    return false;
  }
  if (data?.partners.length > 0) {
    data?.partners.map((item) => {
      if (
        item?.partner_name !== "" &&
        item?.partner_email !== "" &&
        item?.partnership_percentage !== ""
      ) {
        return false;
      }
    });
  } else {
    return true;
  }
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: state.isFocused ? "#f5c0a9 !important" : "#EEEEEE",
    minHeight: "50px",
    height: "50px",
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "50px",
    padding: "0 6px",
    "overflow-y": "auto",
  }),
  input: (provided, state) => ({
    ...provided,
    padding: "2px 0px",
    margin: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "50px",
  }),
};

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

function CreateBuyer() {
  const { t } = useTranslation();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.googleMapsApiKey,
    libraries,
  });
  const industryOptions = [
    { value: "medical_clinic", label: t("hmedical_clinic") },
    { value: "dental", label: t("hdental") },
    { value: "physiotherapy", label: t("hphysiotherapy") },
    { value: "chiropractic", label: t("hchiropractic") },
    { value: "massage_therapy", label: t("hmassage_therapy") },
    { value: "podiatry", label: t("hpodiatry") },
    { value: "psychology", label: t("hpsychology") },
    { value: "veterinary", label: t("hveterinary") },
    { value: "aesthetic_care", label: t("haesthetic_care") },
    { value: "vision_care", label: t("hvision_care") },
    { value: "medical_equipment", label: t("hmedical_equipment") },
    { value: "other", label: t("hother") },
  ];
  const role = userDetails?.result;

  const state = useSelector((state) => state.auth.auth.result);

  const navigate = useNavigate();

  const location = useLocation();
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [availableCountries, setAvailableCountries] = useState([
    {
      value: "Canada",
      label: "Canada",
    },
  ]);
  const [professions, setProfessions] = useState([]);
  const dispatch = useDispatch();
  const [buyerProfiles, setBuyerProfiles] = useState({
    original: [],
    filtered: [],
  });
  const [partners, setPartners] = useState([
    { partner_name: "", partner_email: "", partnership_percentage: 0 },
  ]);

  const addPartner = () => {
    setPartners([
      ...partners,
      { partner_name: "", partner_email: "", partnership_percentage: 0 },
    ]);
  };

  const removePartner = (idx) => {
    setPartners((prev) => prev.filter((_, i) => i !== idx));
  };

  const updatePartner = (index, key, value) => {
    const updated = [...partners];

    if (key === "partnership_percentage") {
      updated[index][key] = value === "" ? "" : parseFloat(value) || 0;
    } else {
      updated[index][key] = value;
    }

    setPartners(updated);
  };

  const totalOwnership = partners.reduce(
    (sum, p) => sum + Number(p.percentage || 0),
    0
  );
  const [gridFilter, setGridFilter] = useState("");

  const [addBuyer, setAddBuyer] = useState(true);

  const [triggered, setTriggered] = useState(false);

  const [buyerDetails, setBuyerDetails] = useState({
    name: "",
    contactName: "",
    contactEmail: "",
    email: "",
    phone: "",
    phone2: "",
    fax: "",
    industries: "",
    industriesOpt: [],
    interestedLocations: "",
    interestedLocationsOpt: [],
    investmentRange: "",
    occupation: "",
    address: "",
    city: "",
    postalCode: "",
    country: "",
    region: "",
    currency: "",
    domain: "",
    startService: "",
    website: "",
    buyer_type: "",
    partners: partners,
    need_professionals: "",
  });

  const [currencyOpt, setCurrencyOpt] = useState([]);

  const [updateBuyer, setUpdateBuyer] = useState({
    cond: false,
    id: null,
  });

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [base64, setBase64] = useState("");

  useEffect(() => {
    getCurrencies();
  }, []);

  useEffect(() => {
    if (location?.state === true) {
      onAddBuyer();
    }
  }, [location?.state]);

  useEffect(() => {
    fetchAllBuyerProfiles();
  }, [state, tableParams.current, tableParams.pageSize]);

  const getCurrencies = () => {
    fetchActiveCurrencies()
      .then((res) => {
        const response = res?.data?.result;

        const responseData = response ? sortList(response) : [];

        setCurrencyOpt(responseData);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  // address autocomplete
  const searchBoxRef = useRef(null);

  const [addressInput, setAddressInput] = useState(buyerDetails?.address || "");

  const handlePlacesChanged = () => {
    console.log(searchBoxRef.current, "adresse");
    if (!searchBoxRef.current) return; //

    updateBuyerDetails("address", "");
    updateBuyerDetails("city", "");
    updateBuyerDetails("region", "");
    updateBuyerDetails("postalCode", "");
    updateBuyerDetails("country", "");
    setAddressInput("");
    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address = "";
      let streetNumber = "";
      let route = "";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address, "adresse");

      setAddressInput(address); // met à jour l'input
      updateBuyerDetails("address", address); // met à jour le state global

      //  updateBusinessDetails("address", address);
      updateBuyerDetails("city", city);
      updateBuyerDetails("region", region);
      updateBuyerDetails("postalCode", postalCode);
      updateBuyerDetails("country", country);
    }
  };
  // End address autocomplete

  const fetchAllBuyerProfiles = async () => {
    if (role?.role?.id !== 3) {
      fetchAllBuyers(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const sortedList = sortList(response?.data ?? []);

          setBuyerProfiles({
            original: [...sortedList],
            filtered: [...sortedList],
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      if (role?.user?.buyerprofile?.id === 0) {
        setBuyerProfiles({
          original: [],
          filtered: [],
        });
      } else {
        const buyerID = role?.user?.buyerprofile?.id ?? null;
        if (buyerID) {
          fetchBuyerDetails(role?.user?.buyerprofile?.id)
            .then((res) => {
              const buyerProfile = res?.data?.result;

              setBuyerProfiles({
                original: [buyerProfile],
                filtered: [buyerProfile],
              });
            })
            .catch((error) => {
              formatError(error.response?.data?.error);
            });
        }
      }

      setTableParams((prevTableParams) => ({
        ...prevTableParams,
        total: 1,
      }));
    }
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = buyerProfiles.original.filter((item) =>
        item?.name.toLowerCase().includes(value.toLowerCase())
      );

      setBuyerProfiles((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setBuyerProfiles((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onAddBuyer = () => {
    setAddBuyer(true);

    setBuyerDetails({
      name: "",
      contactName: role?.user?.firstname + " " + role?.user?.lastname,
      contactEmail: role?.user?.email,
      email: "",
      phone: role?.user?.phone,
      phone2: "",
      fax: "",
      industries: "",
      industriesOpt: [],
      interestedLocations: "",
      interestedLocationsOpt: [],
      investmentRange: "",
      occupation: "",
      address: "",
      city: "",
      postalCode: "",
      country: "Canada",
      region: "North America",
      currency: "",
      domain: "",
      startService: "",
      website: "",
      buyer_type: "",
      partners,
      need_professionals: "",
    });
  };
  useEffect(() => {
    onAddBuyer();
  }, []);

  useEffect(() => {
    setBuyerDetails((prevState) => ({
      ...prevState,
      partners,
    }));
  }, [partners]);
  const updateBuyerDetails = (key, value) => {
    setBuyerDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleKeyDown = (event, optKey, key) => {
    if (!buyerDetails?.[key]) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        event.preventDefault();
        updateBuyerDetails(optKey, [
          ...buyerDetails?.[optKey],
          createOption(buyerDetails?.[key]),
        ]);
        updateBuyerDetails(key, "");
    }
  };

  const addBuyerHandler = (id) => {
    if (validateBuyer(buyerDetails)) {
      setTriggered(true);
    } else {
      setTriggered(false);
      buyerDetails["professional_required"] = professions.map(
        (item) => item.value
      );
      addBuyerProfile(buyerDetails, id)
        .then((res) => {
          setBuyerDetails({
            name: "",
            contactName: "",
            contactEmail: "",
            email: "",
            phone: "",
            phone2: "",
            fax: "",
            industries: "",
            industriesOpt: [],
            interestedLocations: "",
            interestedLocationsOpt: [],
            investmentRange: "",
            occupation: "",
            address: "",
            city: "",
            postalCode: "",
            country: "",
            region: "",
            currency: "",
            domain: "",
            startService: "",
            website: "",
            buyer_type: "",
            partners: partners,
            need_professionals: "",
          });

          if (updateBuyer.cond) {
            setUpdateBuyer({
              cond: false,
              id: null,
            });
          }

          const newSessionDetails = { ...userDetails };

          newSessionDetails.result.user.buyerprofile = res?.data?.result;

          sessionStorage.setItem(
            "userDetails",
            JSON.stringify(newSessionDetails)
          );

          dispatch(loginConfirmedAction(newSessionDetails));
          setAddBuyer(false);
          navigate("/buyer");
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  const onViewBuyer = (id) => {
    navigate(`/buyer/${id}`);
  };

  const onUpdateBuyer = (id) => {
    fetchBuyerDetails(id)
      .then((res) => {
        const data = res.data?.result;

        setUpdateBuyer({
          cond: true,
          id: data?.id,
        });

        setAddBuyer(true);

        setBuyerDetails({
          name: data?.name,
          contactName: data?.contactname,
          contactEmail: data?.contactemail,
          email: data?.email,
          phone: data?.phone,
          phone2: data?.phone2,
          fax: data?.fax,
          industries: "",
          industriesOpt: data?.industries.map((item) => createOption(item)),
          interestedLocations: "",
          interestedLocationsOpt: data?.interestedlocations.map((item) =>
            createOption(item)
          ),
          investmentRange: data?.investmentrange,
          occupation: data?.occupation,
          address: data?.address,
          city: data?.city,
          postalCode: data?.postalcode,
          country: data?.country,
          region: data?.region,
          currency: data?.currency?.id,
          domain: data?.domain,
          startService: modifyDate(data?.startservice),
          website: data?.website,
          buyer_type: data?.buyer_type,
          partners: data?.partners,
          need_professionals: data?.need_professionals,
        });
      })
      .catch((error) => {
        formatError(error?.response?.data?.error);
      });
  };

  const onDeleteBuyer = (id) => {
    swal({
      title: t("are_you_sure"),
      text: t("confirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteBuyerProfile(id)
          .then((res) => {
            swal(t("hsuppressionsuccess"), "", "success");
            fetchAllBuyerProfiles();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };
  const handleRegionChange = (selectedOption) => {
    // setSelectedRegion(selectedOption);

    const region = regionsData.find((r) => r.value === selectedOption?.value);
    // setAvailableCountries(region ? region.countries : []);

    updateBuyerDetails("region", selectedOption?.value || "");

    updateBuyerDetails("country", "");
  };
  const handleCountryChange = (selectedOption) => {
    updateBuyerDetails("country", selectedOption?.value || "");
  };

  useEffect(() => {
    if (buyerDetails.region && buyerDetails.country) {
      const region = regionsData.find((r) => r.value === buyerDetails.region);
      if (region) {
        // setSelectedRegion({ value: region.value, label: region.label });
        // setAvailableCountries(region.countries);
      }
    }
  }, [buyerDetails.region]);
  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", t("hmax50"), "error", {
          button: t("htry"),
        });

        fileInputRef.current.value = "";
        setSelectedFile(null);

        setBase64("");

        return;
      }

      // Check if the selected file is of type jpg or png
      if (fileType === "image/jpeg" || fileType === "image/png") {
        const base64String = await getBase64(file);

        setSelectedFile(file);
        setBase64(base64String);
      } else {
        fileInputRef.current.value = "";

        setSelectedFile(null);
        setBase64("");

        swal("Oops", t("hselectJpg"), "error", {
          button: t("htry"),
        });
      }
    }
  };

  const columns = [
    {
      title: `${t(`buyerProfileCulumn1`)}`,
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t(`buyerProfileCulumn2`)}`,
      dataIndex: "name",
      sorter: true,
      render: (text, record) => {
        return (
          <>
            <span>{text}</span>
            <br />
            <span>{record?.contactemail}</span>
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t(`buyerProfileCulumn3`)}`,
      dataIndex: "country",
      width: "20%",
    },
    {
      title: `${t(`buyerProfileCulumn4`)}`,
      dataIndex: "createdat",
      render: (text) => dateFormatter(text),
      width: "20%",
    },
    {
      title: `${t(`buyerProfileCulumn5`)}`,
      dataIndex: "domain",
      width: "20%",
    },
    {
      title: `${t(`buyerProfileCulumn6`)}`,
      dataIndex: "occupation",
      width: "20%",
    },
    {
      title: `${t(`buyerProfileCulumn7`)}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <button
              className="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewBuyer(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-success mr-2"
              onClick={() => onUpdateBuyer(record?.id)}
            >
              <i className="fa fa-pencil"></i>
            </button>
            {(role?.role?.id === 1 || role?.role?.id === 2) && (
              <button
                className="ms-2 btn btn-xs px-2 light btn-danger"
                style={{ marginRight: "8px" }}
                onClick={() => onDeleteBuyer(record?.id)}
              >
                <i class="fa fa-trash"></i>
              </button>
            )}
          </div>
        );
      },
      width: "20%",
    },
  ];

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <div class="card">
        <div class="card-header d-sm-flex d-block">
          {addBuyer ? (
            <div class="d-flex me-auto mb-sm-0">
              <h3
                class="card-title"
                style={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                {updateBuyer.cond ? t("update") : t("globalCreateButton")}{" "}
                {t("buyerProfileTitle2")}
              </h3>
            </div>
          ) : (
            <>
              <div class="d-flex me-auto mb-sm-0">
                <h3 class="card-title" style={{ fontWeight: "bold" }}>
                  {t("buyerProfileTitle2")}
                  {role?.role?.id !== 3 ? "S" : ""}
                </h3>
              </div>
              <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
              {role?.role?.id === 3 && role?.user?.buyerprofile && (
                <div style={{ paddingLeft: "12px" }}>
                  <button className="btn btn-info" onClick={onAddBuyer}>
                    + {t("buyerProfileCreateButton")}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {!addBuyer && (
          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={buyerProfiles.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        )}
      </div>

      {addBuyer && (
        <div className="row">
          <div className="mb-3 shadow-sm">
            <div
              style={{
                fontWeight: "bold",
                textTransform: "uppercase",
                marginTop: "30px",
                paddingTop: "15px",
                backgroundColor: "#310247",
              }}
            >
              <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                {t("hinfosGeneral")}
              </h4>
              <hr />
            </div>

            <div className="card-body p-0">
              {/* General Information Section */}
              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.name === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("nameInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("nameInput")}
                      className="form-control"
                      value={buyerDetails?.name}
                      onChange={(e) =>
                        updateBuyerDetails("name", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.name === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("nameInput")} {t("globalIsRequired")}{" "}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("emailInput")}</strong>{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder={t("emailInput")}
                      className="form-control"
                      required
                      value={buyerDetails?.email}
                      onChange={(e) =>
                        updateBuyerDetails("email", e.target.value)
                      }
                    />
                    {triggered && buyerDetails?.email === "" && (
                      <div className="text-danger fs-12 mb-3">
                        {t("emailInput")} {t("globalIsRequired")}{" "}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("websiteInput")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder={t("websiteInput")}
                      className="form-control"
                      value={buyerDetails?.website}
                      onChange={(e) =>
                        updateBuyerDetails("website", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.phone === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("phoneInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      placeholder={t("phoneInput")}
                      className="form-control"
                      value={buyerDetails?.phone}
                      onChange={(e) =>
                        updateBuyerDetails("phone", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.phone === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("phoneInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("secondaryPhoneInput")}</strong>
                    </label>
                    <input
                      type="tel"
                      placeholder={t("secondaryPhoneInput")}
                      className="form-control"
                      value={buyerDetails?.phone2}
                      onChange={(e) =>
                        updateBuyerDetails("phone2", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("faxNumberInput")}</strong>
                    </label>
                    <input
                      type="tel"
                      placeholder={t("faxNumberInput")}
                      className="form-control"
                      value={buyerDetails?.fax}
                      onChange={(e) =>
                        updateBuyerDetails("fax", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Business Details Section */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  marginTop: "30px",
                  paddingTop: "15px",
                  backgroundColor: "#310247",
                }}
              >
                <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                  {t("detailsSection")}
                </h4>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.domain === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("domainInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("domainInput")}
                      className="form-control"
                      value={buyerDetails?.domain}
                      onChange={(e) =>
                        updateBuyerDetails("domain", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.domain === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("domainInput")} {t("globalIsRequired")}{" "}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.occupation === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("occupationInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("occupationInput")}
                      className="form-control"
                      value={buyerDetails?.occupation}
                      onChange={(e) =>
                        updateBuyerDetails("occupation", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.occupation === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("occupationInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.buyer_type === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("buyerTypeInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      options={[
                        {
                          value: "partner_buyer",
                          label: t("partnerBuyerOption"),
                        },
                        { value: "end_buyer", label: t("endBuyerOption") },
                      ]}
                      placeholder={t("selectBuyerTypePlaceholder")}
                      styles={customStyles}
                      value={
                        buyerDetails?.buyer_type
                          ? {
                              value: buyerDetails.buyer_type,
                              label:
                                buyerDetails.buyer_type === "partner_buyer"
                                  ? t("partnerBuyerOption")
                                  : t("endBuyerOption"),
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        updateBuyerDetails(
                          "buyer_type",
                          selectedOption?.value || ""
                        )
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.buyer_type === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("buyerTypeInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.startService === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("businessStartDate")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <DatePicker
                      className="form-control"
                      dateFormat="YYYY-MM-DD"
                      placeholderText="YYYY-MM-DD"
                      showYearDropdown={true}
                      value={buyerDetails?.startService}
                      onChange={(e) =>
                        updateBuyerDetails("startService", modifyDate(e))
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.startService === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("businessStartDate")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="mb-1">
                    <strong>{t("photoInput")}</strong>
                  </label>
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={onChangePhoto}
                  />
                </div>

                <div className="col-md-3">
                  <label className="mb-1 d-block">
                    <strong>{t("needProfessionalServiceInput")}</strong>
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="need_professionals"
                      id="needProfessionalServiceYes"
                      value={true}
                      checked={buyerDetails?.need_professionals == "true"}
                      onChange={(e) =>
                        updateBuyerDetails("need_professionals", e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="needProfessionalServiceYes"
                    >
                      {t("yesOption")}
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="need_professionals"
                      id="needProfessionalServiceNo"
                      value={false}
                      checked={buyerDetails?.need_professionals === "false"}
                      onChange={(e) =>
                        updateBuyerDetails("need_professionals", e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="needProfessionalServiceNo"
                    >
                      {t("noOption")}
                    </label>
                  </div>
                </div>
                {buyerDetails?.need_professionals === "true" && (
                  <div className="col-md-12 col-lg-3 col-xl-3 ">
                    <div
                      className={`form-group ${
                        triggered && buyerDetails?.region === ""
                          ? "mb-1"
                          : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <strong>{t("professionalsDomain")}</strong>
                      </label>

                      <MultiSelect
                        options={[
                          {
                            label: t("hbroker"),
                            value: "Real Estate Broker",
                          },
                          {
                            label: t("hbrokerFinance"),
                            value: "Finance Broker",
                          },
                          { label: t("hlawyer"), value: "Lawyer" },
                          { label: t("hfiscaliste"), value: "Fiscalist" },
                        ]}
                        value={professions}
                        onChange={setProfessions}
                        labelledBy="Select"
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* Partners Section */}
              {buyerDetails?.buyer_type === "partner_buyer" && (
                <div className="col-md-12 mt-3">
                  <div
                    style={{
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      marginTop: "30px",
                      paddingTop: "15px",
                      backgroundColor: "#310247",
                    }}
                  >
                    <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                      {t("partnersSection")}
                    </h4>
                    <hr />
                  </div>
                  {partners.map((partner, idx) => (
                    <div className="row mb-2" key={idx}>
                      <div className="col-md-4">
                        <input
                          type="text"
                          placeholder={t("partnerNamePlaceholder")}
                          className="form-control"
                          value={partner.partner_name}
                          onChange={(e) =>
                            updatePartner(idx, "partner_name", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          type="email"
                          placeholder={t("partnerEmailPlaceholder")}
                          className="form-control"
                          value={partner.partner_email}
                          onChange={(e) =>
                            updatePartner(idx, "partner_email", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <div className="input-group">
                          <input
                            type="number"
                            placeholder={t("ownershipPercentagePlaceholder")}
                            className="form-control"
                            value={partner.partnership_percentage}
                            onChange={(e) =>
                              updatePartner(
                                idx,
                                "partnership_percentage",
                                e.target.value
                              )
                            }
                          />
                          <div className="form-control input-group-text custom-group-text">
                            %
                          </div>
                        </div>
                      </div>

                      {idx !== partners.length - 1 && (
                        <div className="col-md-2 d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => removePartner(idx)}
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      )}
                      {idx === partners.length - 1 && (
                        <div className="col-md-2 d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={addPartner}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                  {totalOwnership > 100 && (
                    <div className="text-danger">
                      {t("totalOwnershipExceedsError")}
                    </div>
                  )}
                </div>
              )}

              {/* Investment & Financial Information Section */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  marginTop: "30px",
                  paddingTop: "15px",
                  backgroundColor: "#310247",
                }}
              >
                <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                  {t("investmentFinancialSection")}
                </h4>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.investmentRange === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("investmentRangeInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder={t("investmentRangeInput")}
                      className="form-control"
                      value={buyerDetails?.investmentRange}
                      onChange={(e) =>
                        updateBuyerDetails("investmentRange", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.investmentRange === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("investmentRangeInput")} {t("globalIsRequired")}{" "}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.currency === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("preferredCurrencyInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      options={currencyOpt?.map((item) => ({
                        value: item.id,
                        label: item.code,
                      }))}
                      placeholder={t("selectCurrencyPlaceholder")}
                      styles={customStyles}
                      value={
                        buyerDetails?.currency
                          ? currencyOpt?.find(
                              (item) => item.id === buyerDetails.currency
                            )
                            ? {
                                value: buyerDetails.currency,
                                label: currencyOpt.find(
                                  (item) => item.id === buyerDetails.currency
                                ).code,
                              }
                            : null
                          : null
                      }
                      onChange={(selectedOption) =>
                        updateBuyerDetails(
                          "currency",
                          selectedOption?.value || ""
                        )
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.currency === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("preferredCurrencyInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              {/* Location Information Section */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  marginTop: "30px",
                  paddingTop: "15px",
                  backgroundColor: "#310247",
                }}
              >
                <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                  {t("locationInformationSection")}
                </h4>
                <hr />
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("addressInput")}</strong>
                    </label>
                    <StandaloneSearchBox
                      onLoad={(ref) => (searchBoxRef.current = ref)}
                      onPlacesChanged={handlePlacesChanged}
                    >
                      <input
                        type="text"
                        placeholder={t("addressInput")}
                        className="form-control"
                        value={addressInput}
                        onChange={(e) => {
                          const newAddress = e.target.value;
                          setAddressInput(newAddress);
                          updateBuyerDetails("address", newAddress);
                          updateBuyerDetails("city", "");
                          updateBuyerDetails("region", "");
                          updateBuyerDetails("postalCode", "");
                          updateBuyerDetails("country", "");
                        }}
                      />
                    </StandaloneSearchBox>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("cityInput")}</strong>{" "}
                    </label>
                    <input
                      type="text"
                      placeholder={t("cityInput")}
                      className="form-control"
                      value={buyerDetails?.city}
                      onChange={(e) =>
                        updateBuyerDetails("city", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.region === "" ? "mb-1" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>{t("regionInput")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder={t("regionInput")}
                      className="form-control"
                      value={buyerDetails?.region}
                      onChange={(e) =>
                        updateBuyerDetails("region", e.target.value)
                      }
                    />

                    {/* <select
                      className="form-control"
                      style={{ border: "1px solid #EEEEEE" }}
                      value={buyerDetails?.region}
                      onChange={(e) =>
                        updateBuyerDetails("region", e.target.value)
                      }
                    >
                      <option value="">{t("globalSelect")}</option>
                      <option value="Alberta">{t("halberta")}</option>
                      <option value="British Columbia">
                        {t("hbritishcolumbia")}
                      </option>
                      <option value="Manitoba">{t("hmanitoba")}</option>
                      <option value="New Brunswick">
                        {t("hnewbrunswick")}
                      </option>
                      <option value="Newfoundland and Labrador">
                        {t("hnewfoundland")}
                      </option>
                      <option value="Northwest Territories">
                        {t("hnorthwestterritories")}
                      </option>
                      <option value="Nova Scotia">{t("hnovascotia")}</option>
                      <option value="Nunavut">{t("hnunavut")}</option>
                      <option value="Ontario">{t("hontario")}</option>
                      <option value="Prince Edward Island">{t("hpei")}</option>
                      <option value="Quebec">{t("hquebec")}</option>
                      <option value="Saskatchewan">{t("hsaskatchewan")}</option>
                      <option value="Yukon">{t("hyukon")}</option>
                    </select> */}
                  </div>
                  {triggered && buyerDetails?.region === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("regionInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="mb-1">
                      <strong>{t("postalCodeInput")}</strong>
                    </label>
                    <input
                      type="text"
                      placeholder={t("postalCodeInput")}
                      className="form-control"
                      value={buyerDetails?.postalCode}
                      onChange={(e) =>
                        updateBuyerDetails("postalCode", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.country === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("countryInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("countryInput")}
                      className="form-control"
                      value={buyerDetails?.country}
                      onChange={(e) =>
                        updateBuyerDetails("country", e.target.value)
                      }
                    />
                    {/* <Select
                      isClearable
                      options={availableCountries}
                      placeholder={t("countryPlaceholder")}
                      styles={customStyles}
                      value={
                        buyerDetails?.country
                          ? availableCountries.find(
                              (country) =>
                                country.value === buyerDetails.country
                            ) || null
                          : null
                      }
                      onChange={handleCountryChange}
                      isDisabled={!selectedRegion}
                    /> */}
                  </div>
                  {triggered && buyerDetails?.country === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("countryInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              {/* Industries & Interests Section */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  marginTop: "30px",
                  paddingTop: "15px",
                  backgroundColor: "#310247",
                }}
              >
                <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                  {t("industriesInterestsSection")}
                </h4>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.industriesOpt?.length === 0
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("targetIndustriesInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <CreatableSelect
                      isClearable
                      isMulti
                      options={industryOptions}
                      placeholder={t("selectIndustriesPlaceholder")}
                      styles={customStyles}
                      components={components}
                      value={buyerDetails?.industriesOpt}
                      onChange={(value) =>
                        updateBuyerDetails("industriesOpt", value)
                      }
                      onInputChange={(value) =>
                        updateBuyerDetails("industries", value)
                      }
                      onKeyDown={(e) =>
                        handleKeyDown(e, "industriesOpt", "industries")
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.industriesOpt?.length === 0 && (
                    <div className="text-danger fs-12 mb-3">
                      {t("targetIndustriesInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered &&
                      buyerDetails?.interestedLocationsOpt?.length === 0
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("municipality")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <CreatableSelect
                      isClearable
                      isMulti
                      options={municipaliteis}
                      placeholder={t("selectLocationsPlaceholder")}
                      styles={customStyles}
                      components={components}
                      value={buyerDetails?.interestedLocationsOpt}
                      onChange={(value) =>
                        updateBuyerDetails("interestedLocationsOpt", value)
                      }
                      onInputChange={(value) =>
                        updateBuyerDetails("interestedLocations", value)
                      }
                      onKeyDown={(e) =>
                        handleKeyDown(
                          e,
                          "interestedLocationsOpt",
                          "interestedLocations"
                        )
                      }
                    />
                  </div>
                  {triggered &&
                    buyerDetails?.interestedLocationsOpt?.length === 0 && (
                      <div className="text-danger fs-12 mb-3">
                        {t("interestedBusinessLocationsInput")}{" "}
                        {t("globalIsRequired")}
                      </div>
                    )}
                </div>
              </div>

              {/* Contact Information Section */}
              <div
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  marginTop: "30px",
                  paddingTop: "15px",
                  backgroundColor: "#310247",
                }}
              >
                <h4 style={{ marginLeft: "10px", color: "#FFFFFF" }}>
                  {t("contactInformationSection")}
                </h4>
                <hr />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.contactName === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("contactPersonNameInput")}</strong>{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("contactPersonNameInput")}
                      className="form-control"
                      value={buyerDetails?.contactName}
                      onChange={(e) =>
                        updateBuyerDetails("contactName", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.contactName === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("contactPersonNameInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>

                <div className="col-md-6">
                  <div
                    className={`form-group ${
                      triggered && buyerDetails?.contactEmail === ""
                        ? "mb-1"
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <strong>{t("contactPersonEmailInput")}</strong>
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder={t("contactPersonEmailInput")}
                      className="form-control"
                      value={buyerDetails?.contactEmail}
                      onChange={(e) =>
                        updateBuyerDetails("contactEmail", e.target.value)
                      }
                    />
                  </div>
                  {triggered && buyerDetails?.contactEmail === "" && (
                    <div className="text-danger fs-12 mb-3">
                      {t("contactPersonEmailInput")} {t("globalIsRequired")}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-5">
                  {updateBuyer.cond ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => addBuyerHandler(updateBuyer.id)}
                      >
                        {t("saveButton")}
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => addBuyerHandler(null)}
                      >
                        {t("saveButton")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CreateBuyer;
